import React from 'react';
import { Box, NakedButton, Heading, Text } from '@qga/roo-ui/components';
import { useTooltip } from 'lib/hooks';
import { TooltipWrapper } from './primitives';

export interface OfferDetailsTooltipProps {
  offerDescription?: string | null;
  offerName: string;
}

const OfferDetailsTooltip: React.FC<OfferDetailsTooltipProps> = ({ offerDescription = null, offerName }) => {
  const { triggerProps, tooltipProps, isOpen } = useTooltip('offer-details-button');

  return (
    <NakedButton {...triggerProps} pb={2}>
      <Text color="greys.steel" fontSize="sm" textDecoration="underline">
        View offer terms & conditions
      </Text>

      {isOpen && (
        <Box {...tooltipProps} zIndex={tooltipProps.zIndex ? Number(tooltipProps.zIndex) : undefined}>
          <TooltipWrapper>
            <Heading.h4 fontSize="sm">{offerName}</Heading.h4>
            {offerDescription && <Text>{offerDescription}</Text>}
          </TooltipWrapper>
        </Box>
      )}
    </NakedButton>
  );
};

export default OfferDetailsTooltip;
